<template>
  <main>
    <md-steppers md-active-step="email" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="必須事項の入力"></md-step>
      <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center" v-if="!sent">
      <div class="md-layout-item md-size-90 md-small-size-100">
        <h2 class="md-title">無料トライアルへお進みいただけます。</h2>
        <p>メールアドレスの有効性チェックのため、メールアドレスをご入力ください。<br>
          ご入力されたメールアドレスへシカクマップ無料トライアルお申込用のURLをお送りします。</p>
        <p class="md-caption">※一度トライアルに登録されたメールアドレスは再度登録できません。<br>
          ※無料トライアル登録後に本契約へお進みいただけます。</p>
      </div>
    </div>

    <div class="md-layout md-alignment-center" v-if="sent">
      <div class="md-layout-item md-size-90 md-small-size-100">
        <h2 class="md-title">確認メールを送信しました。</h2>
        <p>
          ご指定のメールアドレスへメールを送信いたしました。<br>
          メール本文にありますURLからトライアル登録に進んでください。
        </p>
        <br>
        <p class="md-body-1">※確認メールが届かない場合、下記をご確認ください。</p>
        <p class="md-caption">
          ・迷惑メールフォルダにメールが振り分けられている可能性がありますので、迷惑メールフォルダも含めご確認ください。<br>
          ・ドメイン指定受信など、一部のメールが届かなくなる設定にしていると、登録確認メールが届かない場合があります。<br>
          ・「no-reply@jon-payment.com」または「jon-web_info@jon.co.jp」からのメールを受信できるように設定してください。<br>
          ・メールアドレスを間違って入力した可能性があります。再度「
          <a :href="$router.resolve({name: 'TrialEmail'}).href">無料トライアルのお申し込み</a>
          」より登録を行ってください
        </p>
        <p class="md-body-1">上記をご確認いただいても解決しない場合は、お手数ですが「お問い合わせ」よりご連絡ください。</p>
      </div>
    </div>

    <form class="md-layout md-alignment-center" novalidate @submit.prevent="validateEmailConfirmation" v-if="!sent">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <flash-message v-if="errorMessages.length" :errors="errorMessages"></flash-message>
        <md-card-content>
          <div class="md-layout md-alignment-center">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="getValidationClass('email')">
                <label>メールアドレス</label>
                <md-input v-model="form.email" :disabled="sending" autofocus required></md-input>
                <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                <span class="md-error"
                      v-if="getValidationResponseMessage('email')">{{ getValidationResponseMessage('email') }}</span>
                <span class="md-error" v-if="!$v.form.email.required">{{ errors.email.required }}</span>
                <span class="md-error" v-else-if="!$v.form.email.email">{{ errors.email.email }}</span>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions class="md-layout">
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-left">
          </div>
          <div class="md-layout-item md-size-60 md-layout md-alignment-center-center">
            <md-button :disabled="sending" class="md-raised md-primary" type="submit">
              <md-icon>mail</md-icon>
              <span>確認メールを送信</span>
            </md-button>
          </div>
          <div class="md-layout-item md-size-20 md-layout md-alignment-center-right">
          </div>
          <div class="md-layout-item md-size-100 md-layout md-alignment-center-left">
            <loading-spinner v-if="sending"></loading-spinner>
          </div>
        </md-card-actions>
      </md-card>
    </form>

    <div class="md-layout md-alignment-center mb-20" v-show="loaded && !sent">
      <div class="md-layout-item md-size-90 md-small-size-100">
        <plan-table md-card="true" v-on:loading-complete-plan="onLoadingCompletePlan"></plan-table>
      </div>
      <div class="md-layout-item md-size-90 md-small-size-100" v-if="!sent">
        <router-link :to="{ name: 'Simulation2' }"><a>料金シミュレーションへ</a></router-link>
      </div>
      <div class="md-layout-item md-size-90 md-small-size-100" v-if="!sent">
        <router-link :to="{ name: 'ContractEmail' }"><a>本契約へ</a></router-link>
      </div>
    </div>

    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
import CommonMixin          from "../../mixins/commonMixin";
import {apiClient, apiList} from '../../modules/apiClient';
import Validation           from "../../modules/validation";
import Common               from "../../modules/common";
import FlashMessage         from "../../components/FlashMessage";
import PlanTable            from "../../components/frontend/PlanTable";
import {validationMixin}    from 'vuelidate'
import {email, required}    from 'vuelidate/lib/validators'
import LoadingSpinner       from '../../components/LoadingSpinner';

export default {
  name      : "TrialEmail",
  components: {LoadingSpinner, PlanTable, FlashMessage},
  mixins    : [validationMixin, CommonMixin],
  data      : () => ({
    trial  : {},
    main   : {},
    loaded : false,
    sending: false,
    sent   : false,
    form   : {
      email: null,
    },
    errors : {
      email: {
        required: Validation.errorMessage(Validation.rules.required, 'emailAddress'),
        email   : Validation.errorMessage(Validation.rules.email, 'emailAddress'),
      }
    },
  }),
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
      }
    };
  },
  methods: {
    onLoadingCompletePlan(plan) {
      this.trial  = plan.trial;
      this.main   = plan.main;
      this.loaded = true;
    },
    postEmailConfirmation() {
      this.sending = true;
      apiClient.post(apiList.verify_email, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.showSnackBar   = true;
            this.successMessage = Common.messages.emailConfirm.successMessage;
            this.sent           = true;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false
            this.$v.$reset()
          });
    },
    clearForm() {
      this.$v.$touch();
      this.errorMessages    = [];
      this.successMessage   = [];
      this.validateResponse = [];
    },
    validateEmailConfirmation() {
      this.clearForm()
      if (!this.$v.$invalid) {
        this.postEmailConfirmation();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";
@import "src/assets/scss/backend";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.md-table {
  margin-bottom: 20px;
}

.md-card-actions {
  .md-button {
    margin-bottom: 20px;
  }
}
</style>
